module.exports = __webpack_public_path__ + "img/ajhp.9156d6e6.png";